import React from "react";
import content from "@/data/content.json";
import { Reveal } from "./Primitives";
import { FlowLines } from "./FlowLines";

const { kpis } = content;

export const Kpis = () => (
  <section data-testid="kpi-band" className="has-lines overflow-hidden bg-[#1e2532] text-white on-dark">
    <FlowLines />
    <div className="mx-auto grid max-w-[1240px] grid-cols-1 px-6 md:grid-cols-3 md:px-10">
      {kpis.map((k, i) => (
        <Reveal key={k.value} delay={i * 0.1}>
          <div
            data-testid={`kpi-${i}`}
            className={`py-12 md:py-16 ${i > 0 ? "border-t border-white/12 md:border-l md:border-t-0 md:pl-12" : ""}`}
          >
            <p className="font-display text-[34px] font-bold leading-none md:text-[42px]">
              <span className="border-b-[3px] border-[#3ecf9b] pb-2">{k.value}</span>
            </p>
            <p className="mt-7 max-w-[290px] text-[15.5px] leading-[1.6] text-white/65">{k.label}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
